import React, { Component } from 'react';
import { Grid, Icon, Card, Label } from 'semantic-ui-react';
import { source } from 'react-aim';
import { dispatch } from '@rematch/core';
import Accordion from '@zippytech/react-toolkit/Accordion'
import '@zippytech/react-toolkit/Accordion/index.css';
import RemoveUserFromWorkspace from '../drive/modals/RemoveUserFromWorkspace'
import DeleteUserFromUnit from '../drive/modals/DeleteUserFromUnit'
import Labels from '../../../common/Labels';
import EllipsisTooltip from './../../../common/EllipsisTooltip'
import camelCaseCovert from '../../../../helpers/convert-camel-case'
@source({
    mouseEnter: (props, component) => dispatch.app.setHelpContext("Participant Information Cards")
})

class UserResourcePane extends Component {

    constructor(props) {
        super(props);
        this.state = {}

    }

    deleteSubOrg(suborg) {
        let deletesuborgObj = Object.assign({}, this.props.userObj);
        deletesuborgObj.role = suborg.role;
        deletesuborgObj.subOrgName = suborg.subOrgName;
        deletesuborgObj.subOrgId = suborg.subOrgId;
        deletesuborgObj.type = 'deleteUserFromUserResourcepane';
        deletesuborgObj.organisation = suborg.subOrgName;
        dispatch.users.addUserToDelete(deletesuborgObj);
        dispatch.users.userDelModalOpen(true);
    }

    render() {
        const disableDeleteOrg = this.props.selectedOrganisation.role === 'Manager' && (!this.props.selectedSubOrg || (
            this.props.selectedSubOrg._id &&
            this.props.selectedOrganisation._id &&
            this.props.selectedSubOrg._id === this.props.selectedOrganisation._id )
        );
        const expandTool = <div className="plusMinusIcons"  >
            <Icon className="close" name="plus circle" />
            <Icon className="open" name="minus circle" />
        </div>

        let counts = {}

        if (this.props.userObj && this.props.userObj.subOrgIdArr) {
            counts.teamLength = <Label>{this.props.userObj.subOrgIdArr.length}</Label>
        }

        return (
            <div className="accordianBox w_100">
                <div className="accordianPanel  w_100">
                    <Accordion expandTool={expandTool} horizontal enableKeyboardNavigation={false}>
                        <div tabTitle="Summary">
                            <div className="acc-header">Summary</div>

                            <Grid >
                                <Grid.Row className="pad_0">
                                    <Grid.Column width={16} >
                                        <Labels
                                            name="Name"
                                            text={`${this.props.userObj.firstName} ${this.props.userObj.lastName}`} />
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row className="pad_0">
                                    <Grid.Column width={16}>
                                        <Labels
                                            name="Email"
                                            text={this.props.userObj.email} />
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row className="pad_0">
                                    <Grid.Column width={16}>
                                        <Labels
                                            name="Role"
                                            text={camelCaseCovert(this.props.userObj.role)} />
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row className="pad_0">
                                    <Grid.Column width={16}>
                                        <Labels
                                            name="Is API user"
                                            text={this.props.userObj.isApiUser? "true": "false"} />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>

                        </div>
                        <div tabTitle={<div>Teams {counts.teamLength} </div>}>
                            <div className="acc-header">Teams {counts.teamLength}</div>

                            <Grid >
                                <Grid.Row >
                                    {this.props.userObj.subOrgIdArr && this.props.userObj.subOrgIdArr.length ?
                                        this.props.userObj.subOrgIdArr.map(function (subOrg, index) {
                                            return (
                                                <Grid.Column width={4} style={{ padding: "0 5px" }} key={index}>
                                                    <Card style={{ margin: "0 0 20px 0" }} >
                                                        <Card.Content style={{ padding: "7px 15px 0px 10px" }} >
                                                            <Labels
                                                                name={<EllipsisTooltip
                                                                    name={subOrg.subOrgName}
                                                                />}
                                                                text={subOrg.role} />
                                                            {
                                                                subOrg.managersCount < 2 && subOrg.role === 'Manager' ?
                                                                    <Icon
                                                                        name="trash alternate"
                                                                        className="disabled-trash"
                                                                        style={{ position: "absolute", top: "3px", right: "0", 'cursor': 'not-allowed', opacity: ".6" }}

                                                                    /> :
                                                                    <Icon
                                                                        onClick={ disableDeleteOrg ? undefined : () => { this.deleteSubOrg(subOrg) }}
                                                                        name="trash alternate"
                                                                        className={`${disableDeleteOrg ? "disabled-trash" : "trash-color"}`}
                                                                        style={{       
                                                                                position: "absolute", top: "3px", right: "0", 
                                                                                cursor: disableDeleteOrg ? "not-allowed" : 'pointer',
                                                                                opacity: disableDeleteOrg ? "0.6" : "1" 
                                                                        }}

                                                                    />
                                                            }

                                                        </Card.Content>
                                                    </Card>
                                                </Grid.Column>


                                            );
                                        }, this)
                                        : "No teams to display."}
                                </Grid.Row>
                            </Grid>
                        </div>
                    </Accordion>
                </div>

                {this.props.isUserDeactivateModal ?
                    <RemoveUserFromWorkspace {...this.props} /> : ''}

                {this.props.userDelModalOpen ?
                    <DeleteUserFromUnit
                        selectedOrganisation={this.props.selectedOrganisation}
                        selectedAccount={this.props.selectedAccount}
                        userToDel={this.props.userToDel}
                        selectedTeamName={this.props.userToDel.subOrgName}
                        userDelModalOpen={this.props.userDelModalOpen}
                        userObj={this.props.userObj}
                        usersList={this.props.usersList}
                    />
                    : ''}
            </div>

        )
    }
}

export default UserResourcePane;